import { FEED_KEY } from '../../index'

import getReduxKey from '../getReduxKey'

type Props = {
  postId: string
  maxLevel?: number | null
  withComments?: boolean | null
}

const getPostPageKey = ({ postId, maxLevel, withComments }: Props) => {
  const id = maxLevel
    ? `${postId}-${maxLevel}`
    : withComments
      ? `${postId}-withComments`
      : postId
  return getReduxKey(FEED_KEY, id)
}

export default getPostPageKey
